import Components from './constants'
export default {
  /**
   * 字典表
   */
  components (type, val) {
    let label = ''
    if(type in Components){
      Components[type].forEach(e => {
        if(e.value == val){
          label = e.label
        }
      })
    }
    return label
  }
}